// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SP9Dz{display:flex;flex-direction:column;height:100%;overflow:hidden}.SP9Dz ._8zHTg{align-items:center;background-color:#fbbd0826;border-bottom:1px solid var(--anchore-separator-color);color:var(--anchore-color-gray-700);display:flex;flex-shrink:0;font-size:.85rem;gap:.5rem;line-height:1.3;padding:.5rem 1rem}.SP9Dz ._8zHTg .VNMuQ{color:var(--anchore-color-gray-600);flex-shrink:0;height:1rem;width:1rem}.SP9Dz .x9jww{align-items:center;border-bottom:1px solid var(--anchore-separator-color);display:flex;flex-shrink:0;gap:.5rem;justify-content:flex-start;padding:1rem}.SP9Dz .x9jww .iXhC2{color:var(--anchore-color-gray-500)}.SP9Dz .ihFIV{flex:1 1;overflow-y:auto;padding-bottom:1rem}.SP9Dz .ihFIV .cEh78{padding:2rem}.SP9Dz .ihFIV .iRcN1{color:var(--anchore-color-gray-500);padding:2rem;text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SP9Dz`,
	"filteredOutNotice": `_8zHTg`,
	"filteredOutNoticeIcon": `VNMuQ`,
	"toolbar": `x9jww`,
	"toolbarLabel": `iXhC2`,
	"body": `ihFIV`,
	"loader": `cEh78`,
	"emptyMessage": `iRcN1`
};
module.exports = ___CSS_LOADER_EXPORT___;
